export enum Mode {
    VideoOnly = "Video",
}
